module.exports = __webpack_public_path__ + "static/media/dont_forget_to_order.1fa32501.png";